export default __webpack_public_path__ + "static/media/img-0314-madagascar-full-face.8b6d74a8.png";